define(function (require) {
  var Backbone = require("backbone");
  var _ = require("underscore");
  var TimeSlotModel = require("site/page/checkout/time-slot-model");

  var TimeSelectionCollection = Backbone.Collection.extend({
    model: TimeSlotModel,

    initialize () {

    },

    loadSlots (data) {
      var slots = data.slots;

      if (data.employee) {
        slots = _.filter(data.slots, _.bind(function (slot) {
          return _.contains(slot.employeeIds, data.employee);
        }, this));
      }

      this.reset(slots);
    },

    getAvailableTimes () {
      return _.map(this.models, _.bind(function (slot) {
        return slot.get("startTime");
      }, this));
    }
  });

  return TimeSelectionCollection;
});
